RESOLVER_TYPE_HOME